"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var event_1 = require("./event");
var Beacon = /** @class */ (function (_super) {
    __extends(Beacon, _super);
    function Beacon() {
        return _super.call(this, "beacon", {}) || this;
    }
    Beacon.prototype._isPrefab = function () {
        return true;
    };
    return Beacon;
}(event_1.default));
exports.default = Beacon;
//# sourceMappingURL=beacon.js.map